import React, { useEffect } from 'react';

// React 19 hoists page metadata. The reference's html language belongs on
// the existing document element, rather than a nested html element.
export function Helmet({ children }) {
  const nodes = React.Children.toArray(children);
  const language = nodes.find(node => node.type === 'html')?.props.lang;
  useEffect(() => {
    if (language) document.documentElement.lang = language;
  }, [language]);
  return <>{nodes.filter(node => node.type !== 'html')}</>;
}
